import { CATEGORY_IDS } from '@/constants'
import { OPTIMIZELY_FEATURE } from '@/optimizely/constants'
import { OptimizelyHookResult } from '@/optimizely/types'
import { useOptimizelyFeature } from '@/optimizely/utils'

export const useSportsPerformerPageNearYouFeature = (categoryId: CATEGORY_IDS | undefined): OptimizelyHookResult => {
    return useOptimizelyFeature(OPTIMIZELY_FEATURE.sportsPerformerPageNearYou, categoryId === CATEGORY_IDS.SPORTS)
}
